import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StepperDialogComponent } from 'src/app/components/stepper-dialog/stepper-dialog.component';
import { Item } from 'src/app/models/SelectItems';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { MenuService } from 'src/app/services/menu.service';
import { UserService } from 'src/app/services/user.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-distributor-list',
  templateUrl: './distributor-list.component.html',
  styleUrls: ['./distributor-list.component.css']
})
export class DistributorListComponent {
  @ViewChild(StepperDialogComponent) stepperDialogComponent!: StepperDialogComponent;
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  canEditPermission:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
  canProductEditPermission:boolean = true;
  showPermissionPopup:boolean = false;
  addBeneficiary() {
    this.stepperDialogComponent.show = true;
  }
  menuId:number = 0;
	menuUrl : string = "";
  uniqueUserId:any;
  productPermissionText:any;
  productPermissionIds:any;
  existingProductPermissionText:any;
  existingProductPermissionIds:any;
  productList:Item[] = [];
  showLoader:boolean = false;
  constructor(private adminService: AdminService, private router:Router,private menuService:MenuService,private generalService: GeneralService, private lookupService:LookUpService, private userService:UserService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {      
      this.menuId = parseInt(obj['menuId'])??0;
      this.menuUrl = obj['menuUrl'];
      this.getPermissions(this.menuId);
    }
     this.getDistributorDetails();
  }

async getDistributorDetails() {
    this.showLoader = true;
    const res = await this.adminService.DistributorDetails1(); 
    this.showLoader = false;   
    if (res != null && res.result) {
      this.graphdata = res.result.data;
      let index=3;
      let sort:string='asc';
      console.log(this.graphdata.sort( (a, b) => {
        if(sort == 'desc')
        {
          if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
              return 1;
          }          
        }
        else
        {
          if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
              return 1;
          }  
        }
        return index;
      }));
      this.graphHeader = res.result.header;
      this.visibleColumnData =  res.result.header.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
      this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
    }
  }

  onActionClick(data:any)
  {
    if(data)
    {
      if(data.action=="View")
      {
        this.router.navigateByUrl(this.viewUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      }
      else if(data.action=="Edit")
      {
        this.router.navigateByUrl(this.editUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
      } 
      else if(data.action=="PermissionsEdit")
      {
        this.showPermissionPopup = true;
        this.uniqueUserId = data.id1;
        this.getInsuranceProductsDDL(data.id1);      
      } 
    }
  }

  onCreateBtnClick(data:any)
  {
    this.router.navigateByUrl(this.createUrl,{ state: { id:data.id, menuId : this.menuId, menuUrl : this.menuUrl, canEdit : this.canEdit, editUrl : this.editUrl }});
  }

  async getPermissions(menuId:number)
  {
    let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
    let res = await this.menuService.GetMenuPermissionsByUserId(obj);
    if(res && res.isSuccess)
    {
      if(res.result.userMenus.length > 0)
      {
        res.result.userMenus.forEach((element:any) => {
          if(element.permissionName.toLowerCase() =="create")
          {
            this.canCreate = true;
            this.createUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="edit")
          {
            this.canEdit = true;
            this.editUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="view")
          {
            this.canView = true;
            this.viewUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="delete")
          {
            this.canDelete = true;
            this.deleteUrl = element.menuCommand;
          }
          else if(element.permissionName.toLowerCase() =="permissionsedit")
          {
            this.canEditPermission = true;
          }
        });
      }      
    }
  }

  async getInsuranceProductsDDL(uniqueUserId:any){
    const res = await this.lookupService.GetUserInsuranceProducts(uniqueUserId)
    if (res != null && res.result) {
      this.productList = res.result.map((m:any) => { return {id : m.id, name : m.name, checked : m.isChecked}});
      this.productPermissionIds = this.productList?.filter((f:any)=>{f.checked == true})?.map((m:any)=> {return m.id}).toString();
      this.productPermissionText = this.productList?.filter((f:any)=>{f.checked == true})?.map((m:any)=> {return m.name}).join(', ');
      //this.setSelectedProducts();
    }
  }

  onMultiSelectChange(selectItems: Item[]): void {
    if(selectItems && selectItems.length > 0){
      this.productPermissionIds = selectItems.map((item:Item) => {return item.id}).toString();
      this.productPermissionText = selectItems.map((item:Item) => {return item.name}).join(', ');
    }
    else
    {
      this.productPermissionIds = "";
      this.productPermissionText = "";
    }
  }

  setSelectedProducts(){
    if(this.productPermissionIds != null && this.productPermissionIds != undefined && this.productPermissionIds != "" && this.productList?.length > 0)
    {
      let langList = this.productPermissionIds.split(",");
      this.productPermissionText = this.productList.filter((f:any)=> {return langList.includes(f.id.toString())}).map((m:any)=>{return m.name}).join(', ');
      this.productList = this.productList.map((obj:Item) => {
        return {...obj, checked : langList.includes(obj?.id?.toString())}
      });
    }
  }

  async SaveUpdateUserProductPermission(){

    swal.fire({
      title:'',
      text: '',
      html: "If you remove any product permissions, it will affect all associated agents. Are you sure you want to continue?",
      showDenyButton: false,
      showCancelButton: true,   
      cancelButtonText:"Don't Continue",     
      denyButtonText: "Don't Continue",
      denyButtonColor:"#0DB561",
      confirmButtonText: "Yes, Continue",
      confirmButtonColor:"#0DB561",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.proceedToUpdate();
      } else if (result.isDenied) {
        this.showPermissionPopup = false;
      }
      //canProcced = result.isConfirmed;
    });
  }

  async proceedToUpdate(){
    let obj = {
      uniqueUserId:this.uniqueUserId,
      productPermission : this.productPermissionIds
    };
    const res = await this.userService.SaveUpdateUserProductPermission(obj)
    if (res != null && res.result) {
      this.showPermissionPopup = false;
      swal.fire({
        position: 'center',
        icon: res.result?.code == 1 ?'success' : 'error',
        title: res.result?.message,
        showConfirmButton: false,
        timer: 3000,
      });
    }    
    else
    {
      this.showPermissionPopup = false;
      swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Something went wrong',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }
}
